<template>
  <div class="spring-four-landing-page">
    <p v-if="!this.organizationDetails.springFourEnabled" v-translate>
      You don't have SpringFour enabled.
    </p>
    <div v-if="this.organizationDetails.springFourEnabled" class="wrapper">
      <p class="heading" v-translate>
        We have partnered with SpringFour to connect you with trusted, local, free resources that
        can help you lower monthly costs and achieve financial stability.
      </p>
      <div
        class="logo-wrapper"
        :style="{ backgroundImage: `url(${require('../assets/images/springfour-logo.png')})` }"
      ></div>
      <LoadingSpinnerButton
        class="button"
        text="Get Started"
        button="button"
        @click="onClickGetStartedUpper"
      />
      <p class="subheading" v-translate>Use the online tool to find help with:</p>
      <IconCard
        v-for="resource in resources"
        :key="resource.title"
        :title="resource.title"
        :icon="resource.icon"
      />
      <p class="subheading" v-translate>and more!</p>
      <div class="divider"></div>
      <p class="disclaimer" v-translate>
        Each organization has been carefully evaluated and approved to ensure that you get
        legitimate help from people who know what they are talking about.
      </p>
      <LoadingSpinnerButton text="Get Started" button="button" @click="onClickGetStartedLower" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserEvent from '@/services/userEvents'
import IconCard from '@/components/IconCard'
import LoadingSpinnerButton from '@/components/LoadingSpinnerButton'
import { analyticsMixin } from '@/services/googleAnalytics'

const RESOURCES = [
  { title: 'Emergency food services', icon: require('../assets/icons/fork.svg') },
  { title: 'Utility savings', icon: require('../assets/icons/events/loss_of_income.png') },
  {
    title: 'Healthcare and prescription savings',
    icon: require('../assets/icons/events/medical.png'),
  },
  { title: 'Childcare', icon: require('../assets/icons/bottle.svg') },
  { title: 'Housing resources', icon: require('../assets/icons/events/eviction.png') },
  { title: 'Financial coaching', icon: require('../assets/icons/cap.svg') },
]

export default {
  name: 'FindResources',
  mixins: [analyticsMixin],
  components: {
    LoadingSpinnerButton,
    IconCard,
  },
  data() {
    return {
      resources: RESOURCES,
    }
  },
  methods: {
    async onClickGetStartedUpper() {
      if (this.user) {
        this.eventsTracker('clicked-cta-upper', this.user.id)
      } else {
        this.eventsTracker('clicked-cta-upper')
      }
      await this.onClickGetStarted()
    },
    async onClickGetStartedLower() {
      if (this.user) {
        this.eventsTracker('clicked-cta-lower', this.user.id)
      } else {
        this.eventsTracker('clicked-cta-lower')
      }
      await this.onClickGetStarted()
    },
    async onClickGetStarted() {
      // Launch SpringFour iframe + popup
      launchMKD(this.organizationDetails.springFourCode)

      // Record user event
      const userEvent = UserEvent.create({
        eventType: UserEvent.options.VIEWED_SPRING_FOUR_RESOURCES,
      })
      await UserEvent.api.create(userEvent)
    },
  },
  computed: mapState(['organizationDetails', 'user']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
.spring-four-landing-page {
  @include screen-container();
  justify-content: flex-start;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.heading {
  font-family: 'Poppins-SemiBold';
  margin: 1rem 0;
}
.subheading {
  font-family: 'Poppins-SemiBold';
  color: var(--dark-brand-color);
  margin: 1rem 0;
  font-size: 1.2rem;
}
.disclaimer {
  margin: 1rem 0;
}
.button {
  margin-bottom: 2rem;
}
.logo-wrapper {
  height: 8rem;
  width: 16rem;
  margin-bottom: 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.divider {
  width: 100%;
  height: 1px;
  background: $soft-gray;
}
</style>
